import useCounter from "../../utils/helpers";
import { DiscordIcon } from "../../utils/Icons";
import { DISCORD_LINK as INVITE } from "./data/DiscordPageData";
export default function DiscordPageHeroSection() {
  const [members, mRef] = useCounter(10000);
  const [teams, tRef] = useCounter(25);
  const [projs, pRef] = useCounter(70);
  return (
    <>
      {/* ── HERO ─────────────────────────────────────────────────── */}
      <section className="dsc-hero">
        <div className="dsc-aurora" aria-hidden>
          <div className="dsc-orb" />
          <div className="dsc-orb" />
          <div className="dsc-orb" />
        </div>
        <div className="dsc-grid" aria-hidden />

        <div className="dsc-hero-inner">
          <div className="dsc-live-badge">
            <span className="dsc-live-dot" />
            Live Community
          </div>

          <h1 className="dsc-h1">
            <span>QUANTUM</span>
            <span className="stroke">LOGICS</span>
            <span className="grd">DISCORD</span>
          </h1>

          <p className="dsc-hero-sub">
            Pakistan's most structured developer community.{" "}
            <strong>10,000+ builders, coders &amp; creators</strong> — organised
            into companies and teams, led by captains and Commanders, scored by
            the Quantum Community portal and powered by automation.
          </p>

          <div className="dsc-cta-row">
            <a
              href={INVITE}
              target="_blank"
              rel="noopener noreferrer"
              className="dsc-btn-join"
            >
              <DiscordIcon size={19} />
              Join the Server
            </a>
            <a href="#community" className="dsc-btn-ghost">
              About the community ↓
            </a>
            <a href="#commander" className="dsc-btn-ghost">
              Meet the Commander ↓
            </a>
          </div>

          <div className="dsc-stats">
            <div className="dsc-stat" ref={mRef}>
              <div className="dsc-stat-n">
                {members >= 10000 ? "10K" : members.toLocaleString()}
                <span className="c">+</span>
              </div>
              <div className="dsc-stat-lbl">Members</div>
              <div className="dsc-stat-shine" />
            </div>
            <div className="dsc-stat" ref={tRef}>
              <div className="dsc-stat-n">
                {teams}
                <span className="c">+</span>
              </div>
              <div className="dsc-stat-lbl">Active Teams</div>
              <div className="dsc-stat-shine" />
            </div>
            <div className="dsc-stat" ref={pRef}>
              <div className="dsc-stat-n">
                {projs}
                <span className="c">+</span>
              </div>
              <div className="dsc-stat-lbl">Projects Shipped</div>
              <div className="dsc-stat-shine" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
